export default {
  title: "",
  subtitle: "Calculation of exchange rates",
  path: "exchange_rate_calculation",
  paragraph: "You will use this endpoint to check exchange rates and values for one or more transactions, so you can check how the exchanged value would be if the FX operation for that transaction was done at that specific time. Below you can see an example of how to use this endpoint:",
  request: {
    method: "POST", 
    endpoint: "/exchanges/calculate",
    payload: {
      "exchange": { 
        "transaction_ids": [
          "9bdf8f35-23c0-4b28-b74e-756d17318e71"
        ]
      }
    },
    responses: {
      "data": {
        "value": "1234.56",
        "user_id": "5e018c08-8a3f-43fd-93cf-11f27ba419e2",
        "to_bank_account_id": "a1db04a1-ddc9-4aa8-a0a5-2c74cf9505d0",
        "ted_tax": "0.0",
        "iof_value": "4.69",
        "iof_rate": "0.38",
        "fx_value": "16.84",
        "fx_rate": "1.0",
        "from_bank_account_id": "cb0b0b2b-55b2-4b40-a956-f1836a36ba63",
        "exchanged_value": "232.8",
        "exchange_rate_spot": "5.23060000",
        "exchange_rate": "5.30298",
        "exchange_currency": "USD",
        "currency": "BRL",
        "bank_transaction_ids": [
          "dcba6dfc-7fca-4e35-93e1-9d8862cc7cdb"
        ]
      }
    }
  },
	parameterPayload: [
  {
    name: "exchange",
    type: "object",
    required: true,
    description: "exchange data containing at least the following required values:"
  },
  {
		name: "exchange.transaction_ids",
		type: "array",
		required: true,
		description: "An array containing the IDs of the transactions you want to calculate the exchange rates"
    }
  ],
  troubleshooting: {
    title: 'Common mistakes',
    messages: [{
      description: 'Various reasons such as: providing a transaction that was created for instant conversion, a pending, exchanged or already wired transaction',
      code: {
        "error": [
          {
            "error": "not_for_exchange_under_request",
            "description": "All transactions must be for exchange under request"
          },
          {
            "error": "transaction_not_identified",
            "description": "All transactions must have been identified before exchanged"
          },
          {
            "error": "transaction_already_exchanged",
            "description": "All transactions must have not been exchanged"
          },
          {
            "error": "transaction_already_wired",
            "description": "All transactions must have not been wired"
          }
        ]
      },
      solution: 'Be sure the status of the transaction is identified and ready to be exchanged (under your request).'
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Exchange/ExchangeCalculate.js